import React from 'react';
import { connect } from 'react-redux';
import { IRootState } from 'app/shared/reducers';
import { Button, Row, Col, Modal, ModalHeader, ModalBody, Alert, ModalFooter } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Storage, Translate, translate } from 'react-jhipster';
import '../../user/profile.scss';
import '../../../sendOtp/sendOtp.scss';
import OtpInput from 'react-otp-input';
import { reSendOtp, sendOtp } from 'app/modules/sendOtp/sendOtp.reducer';
import { actionImageMap, IND, MESSAGE, Rester_Type, STATUS_TYPES } from 'app/config/constants';
import { generateCaptcha } from 'app/modules/account/password-reset/password-reset.reducer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Table } from 'semantic-ui-react';
import { handleGetUserList } from 'app/modules/administration/approve-management/approve-management.reducer';
import moment from 'moment';

export interface IInfoAccountProps extends StateProps, DispatchProps {
  isDisplay: boolean;
  invokeCloseModal: Function;
  data: any;
}

export interface IInfoAccountState {
  visible: boolean;
  color: string;
  message: string;
  isDisable: boolean;
  redirectUrl: boolean;
  alertMess: string;
  isOpenAlert: boolean;
}

export class InfoAccount extends React.Component<IInfoAccountProps, IInfoAccountState> {
  state: IInfoAccountState = {
    visible: false,
    color: 'info',
    message: '',
    isDisable: false,
    redirectUrl: false,
    alertMess: '',
    isOpenAlert: false
  };

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {}

  toggle = () => {
    this.props.invokeCloseModal();
  };
  onDismiss = () => {
    this.setState({ visible: false });
  };

  formatDate = dateString => {
    return moment(dateString).format('DD/MM/YYYY');
  };

  render() {
    return (
      <div className="container-fluid">
        <Modal
          className="modal-lg hide-border-bottom-modal"
          isOpen={this.props.isDisplay}
          toggle={this.toggle}
          size="lg"
          backdrop="static"
          centered={window.location === window.parent.location}
          style={{ maxWidth: window.innerWidth < 768 ? '100%' : '45%' }}
        >
          <ModalHeader toggle={this.toggle}>
            <h3 className="font-weight-bold">Thông tin tài khoản hủy đăng ký</h3>
          </ModalHeader>
          <ModalBody className="custom-scrollbar" style={{ paddingTop: '0px', paddingLeft: '2%', overflow: 'auto' }}>
            <Row>
              <Col md="4">
                <label>Tên người dùng:</label>
              </Col>
              <Col md="8">
                <span className="font-weight-bold">{this.props.data.fullName}</span>
              </Col>
            </Row>
            <Row>
              <Col md="4">
                <label>Ngày đăng ký:</label>
              </Col>
              <Col md="8">
                <span className="font-weight-bold">
                  {this.props.data['requestDate'] ? this.formatDate(this.props.data['requestDate']) : ''}
                </span>
              </Col>
            </Row>
            <Row>
              <Col md="4">
                <label>Trạng thái:</label>
              </Col>
              <Col md="8">
                <span style={{ color: '#4d9235' }}>{STATUS_TYPES['CANCEL_ACCOUNT'][this.props.data['status']]}</span>
              </Col>
            </Row>
            <Row>
              <Col md="4">
                <label>Lý do:</label>
              </Col>
              <Col md="8">
                <span className="font-weight-bold">{this.props.data.reason}</span>
              </Col>
            </Row>
            <Row className="row justify-content-center">
              <Col md="2">
                <Button style={{ width: '100%' }} className="btn-register-white" onClick={this.toggle}>
                  Đóng
                </Button>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  userList: storeState.approveManagement.userList,
  userProfile: storeState.userInfo.userProfile
});
const mapDispatchToProps = {};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InfoAccount);
